export default {
  primary: "#E2147E",
  primary__dark: "#831D64",
  secondary: "#1F2848",
  tertiary: "#0083FF",
  accent: "#82B1FF",
  error: "#F82D2C",
  info: "#54B1F2",
  success: "#A3D946",
  warning: "#FF6B0E",
  mango:"#F9D84C",
  deepSkyBlue: "#0083ff",
  lightGreyBlue: "#ABB1B8",
  paleSkyBlue:"#d7dce0",
  ligthViolet: "#91A3C9",
  reports:"#BB3484"
};
